import { useEffect, useState } from "react"
import Modal from "../../../components/base/Modal"
import { closeSettingsChat, useHub } from "../../../core/Global"
import ChatContactItem from "../models/ChatContactItem"
import Indicator from "../../../components/base/Indicator"
import { API_ROUTES } from "../../../core/Constants"
import PhoneInput from "../../../components/form/PhoneInput"
import DropDown from "../../../components/form/DropDown"
import FlexRow from "../../../components/base/FlexRow"
import Icon from "../../../components/base/Icon"
import { DrawerForm } from "../../../components/drawers/DrawerForm"
import TextBox from "../../../components/form/TextBox"
import { ChatEnvironments } from "../../../core/Enums"
import PhoneNumberSelect from "../../../components/form/PhoneNumberSelect"


interface IProps {
    chat: ChatContactItem
}

export default function ChatSettingsModal(props: IProps) {

    const hub = useHub()

    // PhoneNumberSelect posts no form control of its own, so the line is held here and merged
    // into the body on submit.
    const [senderLineId, senderLineIdSet] = useState<string | undefined>(props.chat.senderLineId)


    return (
        <DrawerForm id="modal-chat-settings"
            title="Chat Settings"
            onClose={closeSettingsChat}
            buttonText="Update Settings"
            onSubmit={(body, callback) => {
                hub.Post(API_ROUTES.Chat + "settings/" + props.chat.chatId, { ...body, senderLineId }, res => {
                    if (res.success) {

                    }
                    callback!(res)
                })
            }}>
            <div>

                <TextBox id="txt-chatsettings-name" key="txt-chatsettings-name"
                    name="title" label="Chat Title" labelUp block value={props.chat.title} />

                {
                    props.chat.isGroup ?
                        <>
                            <DropDown id="drp-chatsettings-assignedtech" key="drp-chatsettings-assignedtech" name="techId"
                                label="Technician" labelUp block parentModal="modal-chat-settings" dataText="fullName" dataValue="id"
                                apiSource={API_ROUTES.Technicians + "all"} forceSelectValue={props.chat.tech?.id} />
                        </>
                        :
                        <>

                            {
                                props.chat.tech &&
                                <DropDown id="drp-phonelines-envirmnetsss" key="drp-phonelines-envirmnetsss" name="environment"
                                    label="Chat Environment" labelUp block parentModal="modal-chat-settings"
                                    source={[
                                        {
                                            id: "1",
                                            name: "GSM"
                                        },
                                        {
                                            id: "2",
                                            name: "WhatsApp"
                                        },
                                        {
                                            id: "3",
                                            name: "Rinvox App"
                                        }
                                    ]}
                                    forceSelectValue={props.chat.environment?.toString()} />
                            }

                            {
                                props.chat.environment == ChatEnvironments.GSM &&
                                <PhoneNumberSelect id="drp-phonelines-chatsender" name="senderLineId"
                                    label="GSM Sender" labelUp block
                                    value={senderLineId} onChange={senderLineIdSet} />
                            }

                        </>
                }


            </div>
        </DrawerForm>
    )
}